import { createFileRoute, useNavigate, redirect } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { IndentForm } from "@/features/indents/IndentForm";
import { INDENT_KINDS, type IndentKind } from "@/features/indents/types";
import { canCreatePurchaseIndent } from "@/lib/roles";
import { currentUserQueryOptions } from "@/hooks/useCurrentUser";

export const Route = createFileRoute("/_authenticated/indents/new")({
  validateSearch: (s: Record<string, unknown>) => {
    const k = (s.kind as string) ?? "asset";
    return { 
      kind: (INDENT_KINDS as readonly string[]).includes(k) ? (k as IndentKind) : ("asset" as IndentKind),
      itemId: (s.itemId as string) || undefined,
    };
  },
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(currentUserQueryOptions());
    if (!canCreatePurchaseIndent(me.roles)) throw redirect({ to: "/indents" });
  },
  component: NewIndentPage,
});

function NewIndentPage() {
  const navigate = useNavigate();
  const { kind, itemId } = Route.useSearch();
  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <Button variant="ghost" size="sm" onClick={() => navigate({ to: "/indents" })}><ArrowLeft className="mr-1 h-4 w-4" />Back</Button>
      <IndentForm initialKind={kind} initialItemId={itemId} />
    </div>
  );
}
